import React, { Component } from "react";
import { injectStripe, StripeProvider, Elements } from "react-stripe-elements";
import PaymentRequestButton from "./PaymentRequestButton";

export default class ProviderContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stripeLoaded: false
    };
  }
  componentDidMount = () => {
    window && window.Stripe
      ? this.setState({ stripeLoaded: true })
      : setTimeout(
          function() {
            window.Stripe && this.setState({ stripeLoaded: true });
          }.bind(this),
          5000
        );
    // console.log(this.props);
  };

  render() {
    const { stripeLoaded } = this.state;
    if (stripeLoaded) {
      return (
        <StripeProvider apiKey="pk_test_uNWjlfbUWZxMqNTgejG8ixkh">
          <Elements>
            <PaymentRequestButton parent={Object.assign({}, this.props)} />
          </Elements>
        </StripeProvider>
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Booking/FormContainer/PRBContainer.jsx